import { Button } from '../buttons';

import './QtyStepper.scss';

/** Пропсы степпера количества QtyStepper. */
export interface QtyStepperProps {
  /** текущее количество */
  value: number;
  /** «−»: уменьшить на единицу */
  onDecrement?(): void;
  /** «+»: увеличить на единицу */
  onIncrement?(): void;
  /** текст чипа быстрой установки («×4»); не задан — чипа нет */
  quickSetLabel?: string;
  /** подсказка чипа быстрой установки (title) */
  quickSetTitle?: string;
  onQuickSet?(): void;
  className?: string;
}

/**
 * Степпер количества «− n +» с опциональным чипом быстрой установки
 * («×4» у позиций «за колесо»). Кнопки — core Button (outline-secondary, sm).
 * Выделено из мастера ШМ (tfw-cart-qty) в коллекцию ui.
 */
const QtyStepper = (props: QtyStepperProps) => {
  const {
    value, onDecrement, onIncrement,
    quickSetLabel, quickSetTitle, onQuickSet,
    className,
  } = props;

  return (
    <span className={ [
      'qty-stepper',
      'd-inline-flex',
      'align-items-center',
      className || '',
    ].filter(Boolean).join(' ') }
    >
      <Button
        variant='outline-secondary'
        size='sm'
        text='−'
        onClick={ onDecrement }
      />
      <span className='qty-stepper-value mx-1'>{ value }</span>
      <Button
        variant='outline-secondary'
        size='sm'
        text='+'
        onClick={ onIncrement }
      />
      { quickSetLabel && onQuickSet && (
        <Button
          className='qty-stepper-chip ml-1'
          variant='outline-secondary'
          size='sm'
          text={ quickSetLabel }
          title={ quickSetTitle }
          onClick={ onQuickSet }
        />
      ) }
    </span>
  );
};

export default QtyStepper;
